import styles from './styles.module.css'

import posteiLogo from '../../assets/logos/postei-logo.svg'
import posteiLogoText from '../../assets/logos/postei-logo-text.svg'
import { useNavigate } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

function DefaulterPage({ userDefaulter, guestUser, setUserDefaulter }) {
  const navigation = useNavigate()
  const { t } = useTranslation()

  // useEffect(() => {
  //   console.log('userDefaulter', userDefaulter)
  //   console.log('guestUser', guestUser)
  // }, [])

  const handleNavigate = (route) => {
    event.preventDefault()
    navigation(`${route}`)
  }

  return (
    <div className={styles.page}>
      <div className={styles.container_form}>
        <form>
          <div className={styles.form_header}>
            <div className={styles.logo}>
              {/* <img src={posteiLogo} alt="posteiLogo" style={{ height: 34 }} /> */}
              <img
                src={posteiLogoText}
                alt="posteiLogoText"
                style={{ height: 34 }}
                //onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          </div>
          <div className={styles.divider} />
          <div className={styles.form_body}>
            <h1>{t('defaulter_title')}</h1>
            <div className={styles.form_body_title}>
              <p>
                {t('defaulter_greeting', {
                  name: userDefaulter.userDefaulter
                    ? userDefaulter.userDefaulter.name
                    : userDefaulter.name,
                })}
              </p>
              {userDefaulter.isGuest ? (
                <>
                  <p className={styles.form_info}>{t('defaulter_guest_p1')}</p>
                  <p className={styles.form_info}>{t('defaulter_guest_p2')}</p>
                  <p className={styles.form_info}>{t('defaulter_guest_p3')}</p>
                </>
              ) : (
                <>
                  <p className={styles.form_info}>{t('defaulter_user_p1')}</p>
                  <p className={styles.form_info}>{t('defaulter_user_p2')}</p>
                  <p className={styles.form_info}>{t('defaulter_user_p3')}</p>
                  <p className={styles.form_info}>{t('defaulter_user_p4')}</p>
                  <p className={styles.form_info}>{t('defaulter_user_p5')}</p>
                </>
              )}

              <p className={styles.form_info}>
                {t('defaulter_thanks')}
                <br /> {t('defaulter_regards')}
                <br />{' '}
                <a href="https://xama.ai/">
                  <strong>xama.ai</strong>
                </a>
              </p>
            </div>
          </div>

          <div className={styles.form_footer}>
            <button
              className={styles.button_cancel}
              onClick={() => handleNavigate('/')}
            >
              {t('account_selection_exit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default DefaulterPage
